// extracted by mini-css-extract-plugin
export default {"CreateRequest__subtitle":"CreateRequest_CreateRequest__subtitle__3NNfu","CreateRequest__item":"CreateRequest_CreateRequest__item__gFfVJ"};